module.exports = __webpack_public_path__ + "5cb908f7c43a6312e90877c5aab6d8db.pdf";